// extracted by mini-css-extract-plugin
module.exports = {"LanguageSelector":"LanguageSelector_LanguageSelector__22Oym","LanguageItem":"LanguageSelector_LanguageItem__JXDRb","Image":"LanguageSelector_Image__3_E_n"};